import { useNavigate } from 'react-router'
import { GoChevronLeft } from 'react-icons/go'

interface Props {
  username: string
  email: string
}

const Information: React.FC<Props> = ({ username, email }) => {
  const navigate = useNavigate()

  return (
    <div className="flex h-full w-full flex-col text-sm">
      <div className="flex h-[50px] items-center pl-[10px] text-xl font-semibold">
        <div className="flex items-center">
          <button
            type="button"
            className="hover-main mr-[10px] flex h-[30px] w-[30px] items-center justify-center rounded-full"
            onClick={() => {
              navigate('../account')
            }}
          >
            <GoChevronLeft />
          </button>
          <h1>Account information</h1>
        </div>
      </div>
      <div className="text-sub pt-[15px] pb-[25px] pl-[25px]">
        These are your account information. Email or username change isn't
        implemented yet.
      </div>
      <div className="flex w-full flex-col pl-[25px] text-lg">
        <h1>
          Email: <span className="text-sub">{email}</span>
        </h1>
        <h1>
          Username: <span className="text-sub">{username}</span>
        </h1>
      </div>
    </div>
  )
}

export default Information
